export const active = {};

export const hover = {};

export const selected = {
  background: 'transparent',
  color: 'inherit',
};

export const focus = {
  border: {
    color: 'focus',
  },
  shadow: 'none',
};
